import React from 'react'
import PropTypes from 'prop-types'
import { typeAny } from 'client/types'
import { typeConfig } from 'src/comps/Page/types'

import ErrorSection from 'client/components/ErrorSection/ErrorSection'
import Footer from 'client/components/Footer'
import Header from 'client/components/Header'
import Page from 'src/comps/Page'
import SearchForm from 'client/components/SearchForm'

import { Layout } from 'client/pages/styles'
import { getInitialProps } from 'src/pages/_error/server'
import { TopDestinationsProvider } from 'src/context/topDestinations'
import { ListOfAncillary } from '@s4l/stayforlong/booking/ListOfAncillary'
import { Advantages } from '@s4l/uikit'

const pageId = 'error'

const ErrorPage = ({ statusCode, config, translations }) => {
  return (
    <Page config={config} translations={translations} pageId={pageId} disableOAuth>
      <Layout>
        <TopDestinationsProvider value={{ destinations: [] }}>
          <Header pageId={statusCode} ancillariesJSON={ListOfAncillary.empty().toJSON()} />
          <ErrorSection notFound={statusCode === 404} />
          <div className="searchForm-container">
            <SearchForm />
          </div>
          <Advantages />
          <Footer />
        </TopDestinationsProvider>
      </Layout>
    </Page>
  )
}

ErrorPage.propTypes = {
  config: typeConfig,
  statusCode: PropTypes.number,
  translations: typeAny,
}

ErrorPage.getInitialProps = getInitialProps

ErrorPage.pageId = pageId
ErrorPage.pagePathView = '/_error'

export default ErrorPage
